import { createAction, props } from '@ngrx/store';

import {
  DrawingToolType,
  IDrawingTool
} from '@live/pages/live-camera-page/components/live-drawing-control-bar/components/live-drawing-tools-selector';
import { IUISpatialAnalysisRule } from '@live/pages/live-camera-page/components/camera-insights/components/spatial-analysis-tab/interfaces';

import { IAction } from '@common/modules/shared/interfaces';

import ISpatialAnalysisRule = Microsoft.VideoIndexer.Live.Contracts.ISpatialAnalysisRule;
import ILiveMonitoredZone = Microsoft.VideoIndexer.Live.Contracts.ILiveMonitoredZone;

// Tool selection actions
export const selectDrawingTool = createAction('[Live Spatial] Select Drawing Tool', props<{ tool: IDrawingTool }>());
export const clearSelectedTool = createAction('[Live Spatial] Clear Selected Tool');

// Spatial analysis actions
export const listSpatialAnalysisRules = createAction('[Live Spatial/API] List Spatial Analysis Rules', props<{ cameraId: string }>());
export const listSpatialAnalysisRulesSuccess = createAction(
  '[Live Spatial/API] List Spatial Analysis Rules Success',
  props<{ rules: ISpatialAnalysisRule[] }>()
);
export const listSpatialAnalysisRulesFailed = createAction('[Live Spatial/API] List Spatial Analysis Rules Failed', props<{ error: string }>());

// Edit mode actions
export const enterEditMode = createAction('[Live Spatial] Enter Edit Mode', props<{ toolType?: DrawingToolType }>());
export const exitEditMode = createAction('[Live Spatial] Exit Edit Mode', props<{ resetInProgressShape?: boolean }>());
export const createSpatialAnalysisRule = createAction('[Live Spatial/API] Create Spatial Analysis Rule', props<{ rule: IUISpatialAnalysisRule }>());
export const createSpatialAnalysisRuleSuccess = createAction(
  '[Live Spatial/API] Create Spatial Analysis Rule Success',
  props<{ rule: ISpatialAnalysisRule }>()
);
export const createSpatialAnalysisRuleFailed = createAction('[Live Spatial/API] Create Spatial Analysis Rule Failed', props<{ error: string }>());
export const updateSpatialAnalysisRule = createAction(
  '[Live Spatial/API] Update Spatial Analysis Rule',
  props<{ id: string; rule: IUISpatialAnalysisRule }>()
);
export const updateSpatialAnalysisRuleSuccess = createAction(
  '[Live Spatial/API] Update Spatial Analysis Rule Success',
  props<{ rule: ISpatialAnalysisRule }>()
);
export const updateSpatialAnalysisRuleFailed = createAction('[Live Spatial/API] Update Spatial Analysis Rule Failed', props<{ error: string }>());
export const deleteSpatialAnalysisRule = createAction('[Live Spatial/API] Delete Spatial Analysis Rule', props<{ ruleId: string }>());
export const deleteSpatialAnalysisRuleSuccess = createAction('[Live Spatial/API] Delete Spatial Analysis Rule Success', props<{ ruleId: string }>());
export const deleteSpatialAnalysisRuleFailed = createAction('[Live Spatial/API] Delete Spatial Analysis Rule Failed', props<{ error: string }>());

// Drawing state actions
export const startDrawing = createAction('[Live Spatial] Start Drawing');
export const stopDrawing = createAction('[Live Spatial] Stop Drawing');
export const completeShape = createAction('[Live Spatial] Complete Shape', props<{ shapeData: ISpatialAnalysisRule }>());
export const updateInProgressShape = createAction('[Live Spatial] Update In Progress Shape', props<{ shapeData: IUISpatialAnalysisRule }>());
export const markInProgressShapeAsUpdating = createAction('[Live Spatial] Mark In Progress Shape As Updating');
export const updateCurrentEditableRuleId = createAction('[Live Spatial] Update Current Editable Rule Id', props<{ ruleId: string }>());

export const selectPlayerFilters = createAction('[Live Spatial] Select player filters', props<{ counters: IAction[]; boxes: IAction[] }>());
export const togglePlayerCounters = createAction('[Live Spatial] Toggle player counters', props<{ counterValues: string[] }>());
export const togglePlayerBoxes = createAction('[Live Spatial] Toggle player boxes', props<{ boxValues: string[] }>());
export const toggleSpatialInsights = createAction('[Live Spatial] Toggle spatial insights', props<{ excludedInsights: string[] }>());

// Monitored zone actions
export const listMonitoredZones = createAction('[Live Spatial/API] List Monitored Zones');
export const listMonitoredZonesSuccess = createAction(
  '[Live Spatial/API] List Monitored Zones Success',
  props<{ monitoredZones: ILiveMonitoredZone[] }>()
);
export const listMonitoredZonesFailed = createAction('[Live Spatial/API] List Monitored Zones Failed', props<{ error: string }>());
export const createMonitoredZone = createAction('[Live Spatial/API] Create Monitored Zone', props<{ monitoredZone: ILiveMonitoredZone }>());
export const createMonitoredZoneSuccess = createAction(
  '[Live Spatial/API] Create Monitored Zone Success',
  props<{ monitoredZone: ILiveMonitoredZone }>()
);
export const createMonitoredZoneFailed = createAction('[Live Spatial/API] Create Monitored Zone Failed', props<{ error: string }>());
